<script>
  import jQuery from "jquery";
  import axios from "axios";
  import { setContext, onMount } from "svelte";
  import getCsrfToken from "common/utils/getCsrfToken";
  import debounce from "common/utils/debounce";
  import Chart from "./Chart";
  import Alerts from "./Alerts";
  import {
    show,
    addNotification,
    closeAllNotifications,
  } from "common/notifications/Notifications";

  export let type = "all";
  export let channelId;
  export let url = "";
</script>

{#if type === 'all'}
  <div class="tc-grid">
    <div class="tc-grid--cell">
      <Chart {url} type="ActiveAlerts" />
    </div>
    <div class="tc-grid--cell">
      <Chart {url} type="InputVideoFrameRate" />
    </div>
  </div>
  <div class="tc-grid">
    <div class="tc-grid--cell">
      <Chart {url} type="NetworkIn" />
    </div>
    <div class="tc-grid--cell">
      <Chart {url} type="NetworkOut" />
    </div>
  </div>
  <div class="tc-grid">
    <div class="tc-grid--cell">
      <Chart {url} type="FillMsec" />
    </div>
    <div class="tc-grid--cell">
      <Chart {url} type="DroppedFrames" />
    </div>
    <div class="tc-grid--cell">
      <Chart {url} type="SvqTime" />
    </div>
  </div>

  <Alerts {channelId} />
{:else}
  <div class="tc-grid">
    <div class="tc-grid--cell">
      <Chart {url} type="InputVideoFrameRate" />
    </div>
    <div class="tc-grid--cell">
      <Chart {url} type="NetworkIn" />
    </div>
  </div>
{/if}
